import { atom } from "recoil";
import { ResponseUser } from "../../types/account";

// 이름 나중에 userState로 변경하면 어떨지?
export const accountState = atom<ResponseUser | null>({
  key: "accountState",
  default: null,
});
